import React, { useState, useEffect } from "react";
import '../../index.css';

const initialSections = [
  { id: 1, name: "A", className: "Class 1", teacher: "John Doe", status: "Active" },
  { id: 2, name: "B", className: "Class 2", teacher: "Jane Smith", status: "Inactive" },
  { id: 3, name: "C", className: "Class 3", teacher: "David Lee", status: "Active" },
];

export default function Section() {

  const STORAGE_KEY = "sections";
  const [sectionList, setSectionList] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    className: "",
    teacher: "",
    status: "Active"
  });

  // 🔍 FILTER
  const filteredSections = sectionList.filter((s) =>
    s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    s.className.toLowerCase().includes(searchTerm.toLowerCase()) ||
    s.teacher.toLowerCase().includes(searchTerm.toLowerCase()) ||
    s.status.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ADD
  const openAddModal = () => {
    setIsEdit(false);
    setFormData({
      id: "",
      name: "",
      className: "",
      teacher: "",
      status: "Active"
    });
    setShowModal(true);
  };

  // UPDATE
  const openEditModal = () => {
    if (!selectedSection) {
      alert("Select a section first");
      return;
    }
    setIsEdit(true);
    setFormData(selectedSection);
    setShowModal(true);
  };

  // DELETE
  const handleDelete = () => {
    if (!selectedSection) {
      alert("Select a section first");
      return;
    }

    const updated = sectionList.filter(
      (s) => s.id !== selectedSection.id
    );

    setSectionList(updated);

    //  SAVE
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    window.dispatchEvent(new Event("storage"));

    setSelectedSection(null);
  };

  // SAVE
  const handleSave = () => {

    if (!formData.name || !formData.className || !formData.teacher) {
      alert("All fields required");
      return;
    }

    let updatedList = [];

    if (isEdit) {
      updatedList = sectionList.map((s) =>
        s.id === formData.id ? formData : s
      );
    } else {
      const newSection = {
        ...formData,
        id: Date.now(),
      };

      updatedList = [newSection, ...sectionList];
    }

    setSectionList(updatedList);

    //  SAVE
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedList));
    window.dispatchEvent(new Event("storage"));

    setShowModal(false);
    setSelectedSection(null);
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    if (saved.length === 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialSections));
      setSectionList(initialSections);
    } else {
      setSectionList(saved);
    }
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      setSectionList(saved);
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return (
    <>
      <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header { display:flex; justify-content:space-between; margin-bottom:10px; }

        .controls { display:flex; gap:10px; margin-bottom:10px; flex-wrap:wrap; }

        .search-box {
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .btn { padding:7px 12px; border:none; border-radius:4px; cursor:pointer; }
        .btn-dark { background:#2c3e50; color:white; }
        .btn-blue { background:#3498db; color:white; }
        .btn-red { background:#e74c3c; color:white; }

        table { width:100%; border-collapse:collapse; }
        th, td { padding:10px; border-bottom:1px solid #eee; }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }

        .status { color:green; }

        input[type="checkbox"] {
          cursor:pointer;
        }

        /* MODAL */
        .modal {
          position:fixed;
          top:0;
          left:0;
          width:100%;
          height:100%;
          background:rgba(0,0,0,0.5);
          display:flex;
          justify-content:center;
          align-items:center;
        }

        .modal-content {
          background:white;
          padding:20px;
          border-radius:8px;
          width:350px;
        }

        .modal-content input,
        .modal-content select {
          width:100%;
          margin-bottom:10px;
          padding:8px;
        }
      `}</style>

      <div className="page">
        <div className="card">

          {/* HEADER */}
          <div className="header">
            <h3>Section</h3>
            <div>{sectionList.length} Records</div>
          </div>

          {/* CONTROLS */}
          <div className="controls">

            <input
              className="search-box"
              placeholder="Search section, class, teacher..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <button className="btn btn-dark" onClick={openAddModal}>
              + Add Section
            </button>

            <button className="btn btn-blue" onClick={openEditModal}>
              Update
            </button>

            <button className="btn btn-red" onClick={handleDelete}>
              Delete
            </button>
          </div>

          {/* TABLE */}
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Section</th>
                <th>Class</th>
                <th>Teacher</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filteredSections.map((s) => (
                <tr
                  key={s.id}
                  className={selectedSection?.id === s.id ? "active-row" : ""}
                  onClick={() =>
                    setSelectedSection(
                      selectedSection?.id === s.id ? null : s
                    )
                  }
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedSection?.id === s.id}
                      onChange={() =>
                        setSelectedSection(
                          selectedSection?.id === s.id ? null : s
                        )
                      }
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>

                  <td>{s.name}</td>
                  <td>{s.className}</td>
                  <td>{s.teacher}</td>
                  <td className="status">{s.status}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

        {/* MODAL */}
        {showModal && (
          <div className="modal">
            <div className="modal-content">

              <h3>{isEdit ? "Update Section" : "Add Section"}</h3>

              <input
                placeholder="Section Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />

              <input
                placeholder="Class Name"
                value={formData.className}
                onChange={(e) =>
                  setFormData({ ...formData, className: e.target.value })
                }
              />

              <input
                placeholder="Teacher Name"
                value={formData.teacher}
                onChange={(e) =>
                  setFormData({ ...formData, teacher: e.target.value })
                }
              />

              <select
                value={formData.status}
                onChange={(e) =>
                  setFormData({ ...formData, status: e.target.value })
                }
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>

              <div style={{ display: "flex", gap: "10px" }}>
                <button className="btn btn-blue" onClick={handleSave}>
                  Save
                </button>

                <button
                  className="btn btn-red"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </>
  );
}